import { ComponentProps } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Box } from '../layout/Box';

const blink = keyframes`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;

export interface SkeletonProps extends ComponentProps<typeof Box> {
    ratio?: number;
    variant?: 'text' | 'circular' | 'rect';
}

export const Skeleton = styled(Box).withConfig({
    displayName: 'Skeleton',
    shouldForwardProp: (prop) => !['ratio', 'variant'].includes(prop),
})<SkeletonProps>`
    background-color: var(--placeholder);
    animation: ${blink} 2s ease-in-out 0.5s infinite;
    font-size: 1rem;

    ${(props) =>
        props.variant === 'text' &&
        css`
            border-radius: 1rem;
            transform-origin: 0 55%;
            transform: scale(1, 0.75);
        `};

    ${(props) =>
        props.variant === 'circular' &&
        css`
            border-radius: 50%;
        `};

    ${(props) =>
        props.ratio &&
        css`
            height: 0;
            padding-bottom: ${100 / props.ratio}%;
        `};
`;

Skeleton.defaultProps = {
    borderRadius: 0.5,
    variant: 'text',
};
